import { render, staticRenderFns } from "./SidebarAddNewPage.vue?vue&type=template&id=b5e03532&"
import script from "./SidebarAddNewPage.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewPage.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports